export const mappedColors = {
  billing_claims: ['#22C55E', '#8191E8', '#EF4444', '#13B9FF', '#EF4444', '#F59E0B', '#526268'],
  billing_era_eob: ['#F59E0B', '#22C55E'],
  billing_superbills: ['#526268', '#22C55E']
};

export const mappedWidgetName = {
  billing_invoices: 'Invoices',
  billing_claims: 'Claims',
  billing_era_eob: 'ERA / EOB',
  billing_superbills: 'Superbills'
};

export const mappedCountField = {
  billing_invoices: 'invoices',
  billing_claims: 'claims',
  billing_era_eob: 'eras',
  billing_superbills: 'superbills'
};

export const mappedNavigateRoute = {
  billing_invoices: './electronic-invoicing',
  billing_claims: './claims',
  billing_era_eob: './era',
  billing_superbills: './superbills'
};

export const mappedLabelValueFields = {
  billing_invoices: { 'Not Paid': 'unpaid', Paid: 'paid' },
  billing_claims: {
    ready: 'ready',
    acknowledged: 'acknowledged',
    denied: 'denied',
    paid: 'paid',
    rejected: 'rejected',
    pending: 'pending',
    archived: 'archived'
  },
  billing_era_eob: { pending: 'pending', finalized: 'finalized' },
  billing_superbills: { 'Not scrubbed': 'draft', Scrubbed: 'complete' }
};
